import "./MDLSection.scss"
import { ReactNode } from "react";

function MDLSection(props: { title?: string; content: ReactNode }) {
  return (
    <div className="mdl-section">
      {props.title ? (
        <h2 className="mdl-section-title">{props.title}</h2>
      ) : (
        <></>
      )}
      <div className="mdl-section-content">{props.content}</div>
    </div>
  );
}

export default MDLSection;
